module.exports = __webpack_public_path__ + "static/media/evac-pod-info-alert.588e9655.svg";